import React, {useEffect, useState} from "react";
import LoadingOverlay from 'react-loading-overlay';

import {mainStyle, mainColor, header, footer, otherColors} from '../../utility/styles';

import { allRemoteSettingsSelect } from '../../redux/selectors/index';
import { useSelector, useDispatch } from 'react-redux';
import {authActions} from '../../redux/actions';
import Notify from './Notify';
import Navbar from "../layouts/Navbar";
import MobileBreaker from "../layouts/MobileBreaker";
import BounceLoader from 'react-spinners/BounceLoader'
import FadeLoader from 'react-spinners/FadeLoader'



import { Helmet, HelmetProvider } from 'react-helmet-async';

import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {systemColor} from '../../utility/styles';
import {Router, Route, Switch, HashRouter, useLocation} from "react-router-dom";
import {WebLink} from "./index";
import {useHistory} from "react-router-dom";
import ChatDelegator from '../Livechats/ChatDelegator'

    


function SiteWide(props) {

    const {title, description, children, removeFooter, ...rest} = props
    const site_settings = useSelector(allRemoteSettingsSelect);
    
    const [masterIsLoading, setMasterIsLoading] = useState(false);


    const titleToUse = title ?? site_settings?.site_settings?.title ?? 'welcome';
    const descToUse = description ?? site_settings?.site_settings?.description ?? 'You are here';
    const siteName = site_settings?.site_settings?.sitename ?? 'dotcom';
    const url = site_settings?.site_settings?.site_url ?? 'dotcom';
    const logo = site_settings?.site_settings?.logo ?? '';
    const favicon = site_settings?.site_settings?.favicon ?? '';


    const systemColorManager = systemColor()

    const { pathname } = useLocation();
      const scriptEl = React.useRef(null);

    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const loadHome = () => {
        history.goBack()
    }

    // const bgOverlay = props.overlayBg?systemColorManager.bg_overlay:{}
    const bgOverlay = {}
    
    useEffect(() => {
        setMasterIsLoading(site_settings?.masterIsLoading ?? true)
    }, [site_settings?.masterIsLoading])

    const squareLoading = (props.loading || masterIsLoading)
    
    return (
        <HelmetProvider>
            
            <Helmet>

                <meta name="theme-color" content={systemColorManager.bg_main_color} />

                <title>{titleToUse}</title>
                <link rel="icon" type="image/x-icon" href={favicon} />
                <meta name="viewport" content="initial-scale=1.0, width=device-width" />
                <meta name="description" content={descToUse} />

                <meta property="og:title" content={titleToUse} />
                <meta property="twitter:title" content={titleToUse} />
      
                <meta property="og:site_name" content={siteName} />
                <meta property="twitter:site" content={siteName} />

                <meta property="og:description" content={descToUse} />
                <meta property="twitter:description" content={descToUse} />
      
                <meta property="og:type" content="website" />

                <meta property="og:url" content={url} />

                <meta property="og:image" content={logo} />
                <meta property="twitter:image" content={logo} />

                <meta name="twitter:card" content="summary_large_image" />

            </Helmet>

             <Notify/>
            <MobileBreaker thirdBackgroundColor="#fff">
                
                <Navbar />
            
                <div className="mother-of-all" {...rest} style={{...systemColorManager.bg_main}} >

                    <div className="mainChildren" style={{...bgOverlay, padding: 15}}>
                        
                        <section className="main-section" style={{...props.sectionstyle, paddingTop: 90}}>
        
                            
                            {!props.hideHeader && <Header back={props.back} title={props.title} rightTopMenu={props.rightTopMenu} home={props.home} searchPopup={props.searchPopup} />}
                
                           

                            {props.title && <div className=""  style={{}}>
                                <div className="container">

                                    <div className="h6" style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', ...systemColorManager.txt_3}}>

                                        <WebLink onClick={loadHome} className="menu-back-page home-clicked" style={{flex: 1, ...systemColorManager.txt_1}}>
                                            <i className="fa fa-long-arrow-left" style={{...systemColorManager.txt_1}} /> Back
                                        </WebLink>
                                    
                                        {/*<div className="page-name" style={{marginLeft: 12, ...systemColorManager.txt_1}}>{props.title}</div>*/}

                                        <WebLink to={"/"} className="page-name" style={{marginLeft: 12, ...systemColorManager.txt_1}}>
                                            Home
                                        </WebLink>

                                    </div>

                                </div>
                            </div>}






                            {children}
                
                            <br />

                            {!removeFooter && <Footer />}

                            {squareLoading && <LoadingOverlay
                                active={squareLoading}
                                styles={{


                                        overlay: (base) => ({
                                          ...base,
                                          background: 'transparent',
                                          borderRadius: 5,
                                          color: '#000',
                                        }),

                                       
                                        wrapper: {
                                            width: '130px',
                                            height: 'auto',
                                            padding: '5px',
                                             background: 'rgba(0, 0, 0, 0.7)',
                                            position: squareLoading?'fixed':'none',
                                            zIndex: '999999999999999999999999',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            color: '#000'
                                        }
                                    }}
                            >
                                <div className="text-center" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 10}}>

                                    <FadeLoader color="#36d7b7" />
                                    <br />
                                    <h6 style={{...systemColorManager.txt_1, marginTop: 10}}>
                                        {(props.overlayText ?? '' !='') ?props.overlayText: 'Requesting...'}
                                    </h6>

                                </div>


                            </LoadingOverlay>}


                        </section>

                    </div>

                </div>



            </MobileBreaker> 
            
            {(site_settings?.site_settings?.livechat_sitewide_floating_icon ?? 0) == 1 && <ChatDelegator />}


        </HelmetProvider>
    );
}

export default SiteWide;


